import { Component, HostListener, OnInit } from '@angular/core';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { User } from '@app/shared/interfaces';
import { IntercomService } from '@app/shared/services/intercom.service';
import { SearchResult } from '../../models/support-documentation';
import { OverlaySimulatorService } from '../../services/overlay-simulator.service';
import { SupportDocumentationService } from '../../services/support-documentation.service';

@Component({
  standalone: false,
  selector: 'sbnb-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
})
export class SearchComponent implements OnInit {
  loading: boolean;
  search = '';
  result: SearchResult;
  user: User;

  constructor(
    public overlaySimulatorService: OverlaySimulatorService,
    private authService: AuthenticationService,
    private supportDocumentationService: SupportDocumentationService,
    private readonly intercomService: IntercomService
  ) { }

  ngOnInit(): void {
    this.user = this.authService.getUserDetails();
    this.updateSearchResults();
  }

  get hasResult() {
    return this.result.has_results || this.result.empty_query;
  }

  updateSearchResults() {
    this.loading = true;
    this.supportDocumentationService.search(this.search).subscribe((result: SearchResult) => {
      this.result = result;
      this.loading = false;
    });
  }

  @HostListener('window:keydown.escape')
  close() {
    this.overlaySimulatorService.close();
  }

  talkToSupport(query: string) {
    this.intercomService.showNewMessage(query);
  }
}
